import { ChainId } from "../../packages/swap-sdk/src";
import { Block } from "../state/info/types"
import { getProvider } from "./providersV2";

export const getBlocksBase = async (
    timestamps: number[]
  ): Promise<Block[]> => {
  
  const blockNumber = await getProvider.getBlockNumber();
  // t24h, t48h, t7d, t14d
  const blocks: Block[] = []
  // 24h => blocks (24*60*60/3)
  blocks.push({
    timestamp: timestamps[0].toString(),
    number: Number(blockNumber.toString()) - 28800
  });

  // 48h => second => blocks (48*60*60/3)
  blocks.push({
    timestamp: timestamps[1].toString(),
    number: Number(blockNumber.toString()) - 57600
  });

  // 7d => blocks (7*24*60*60/3)
  blocks.push({
    timestamp: timestamps[2].toString(),
    number: Number(blockNumber.toString()) - 201600
  });

  // 14d => blocks (14*24*60*60/3)
  blocks.push({
    timestamp: timestamps[3].toString(),
    number: Number(blockNumber.toString()) - 403200
  });

  return blocks;
}

export const getBlocksBaseChart = async (
  timestamps: number[],
  times: number[]
): Promise<Block[]> => {

  
  
  const blockNumber = await getProvider.getBlockNumber();
  console.log("blockNumber", blockNumber);
  const blocks: Block[] = []

  for (let index = 0; index < timestamps.length; index++) {
    const element = Math.floor(Number(times[index])/3) + 100;
    const _blockNumber = Number(blockNumber.toString()) - element;
    blocks.push({
      timestamp: timestamps[index].toString(),
      number: _blockNumber
    });
  }
  return blocks;
}